import axios from 'axios'

import { BACKEND_URL } from 'consts'
import { actions as commonActions } from 'reducers/common'
import { actions } from 'reducers/link-in-bio'
import { loadCss, getInstaHandle } from 'helpers/link-in-bio'

export const getClubConfig = () => (dispatch, getState) => {
  dispatch(commonActions.updateState({ key: 'loading', value: true }))
  const { subdomain } = getState().common
  if (!subdomain) return
  return loadCss(subdomain)
    .then(() => {
      return axios.get(BACKEND_URL + '/linktree/config')
    })
    .then(resp => {
      let data = {
        ...resp.data,
        insta_handle: getInstaHandle(resp.data?.social),
      }
      dispatch(actions.updateData({ data }))
      dispatch(commonActions.updateState({ key: 'loading', value: false }))
      dispatch(
        commonActions.updateState({
          key: 'company_id',
          value: parseInt(data.company_id),
        })
      )
      localStorage.setItem('companyId', parseInt(data.company_id))
    })
    .catch(err => {
      // TODO: Temp toString() because the error respnse is malformed (not serializable)
      dispatch(commonActions.updateError(err.toString()))
    })
}
